module.exports = __webpack_public_path__ + "274a483d902eb6ab2a949b38cbf9e50b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/reading/student-icons-review.png
// module id = 3418
// module chunks = 0